let _debug = false;

export function setDebug (val) {
  _debug = !!val;
}

export function debugLog (...args) {
  if (_debug) console.log(...args);
}

export function debugWarn (...args) {
  if (_debug) console.warn(...args);
}
